// Manual token exchange service for Keycloak
export class TokenService {
  constructor() {
    this.keycloakUrl = process.env.REACT_APP_KC_REALM_BASE || 'https://meotrikapm.com/sso/realms/DEV-REALM';
    this.clientId = 'kt-admin-app';
  }

  async exchangeCodeForTokens(code, redirectUri) {
    try {
      const tokenEndpoint = `${this.keycloakUrl}/protocol/openid-connect/token`;
      
      const params = new URLSearchParams({
        grant_type: 'authorization_code',
        client_id: this.clientId,
        code: code,
        redirect_uri: redirectUri,
      });

      console.log('Exchanging code for tokens...');
      console.log('Token endpoint:', tokenEndpoint);
      console.log('Code:', code);

      const response = await fetch(tokenEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: params,
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error('Token exchange failed:', response.status, errorText);
        throw new Error(`Token exchange failed: ${response.status} ${errorText}`);
      }

      const tokenData = await response.json();
      console.log('Token exchange successful:', tokenData);

      return tokenData;
    } catch (error) {
      console.error('Token exchange error:', error);
      throw error;
    }
  }

  async getUserInfo(accessToken) {
    try {
      const userInfoEndpoint = `${this.keycloakUrl}/protocol/openid-connect/userinfo`;
      
      const response = await fetch(userInfoEndpoint, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accessToken}`,
        },
      });

      if (!response.ok) {
        throw new Error(`User info request failed: ${response.status}`);
      }

      const userInfo = await response.json();
      console.log('User info received:', userInfo);

      return userInfo;
    } catch (error) {
      console.error('User info error:', error);
      throw error;
    }
  }

  decodeToken(token) {
    try {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split('')
          .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
          .join('')
      );
      return JSON.parse(jsonPayload);
    } catch (error) {
      console.error('Token decode error:', error);
      throw error;
    }
  }
}

export default new TokenService();
